const TokenKey = "Token";

export function getToken() {
  return sessionStorage.getItem("Authorization");
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function getUserName() {
  return localStorage.getItem("userName");
}

export function setUserName(userName) {
  return localStorage.setItem("userName", userName);
}

export function removeUserName() {
  return localStorage.removeItem("userName");
}
